import React from "react";
import "../../../Style/Services/SecendSection.css";

function SecendSection() {
  return (
    <div className="SecendSection">
      <span className="sub-title">
        Our engineers are capable of designing and implementing various services
        into residential developments, commercial buildings or industrial
        facilities.<br /> We have the required experienced and trained service
        specialists that cater to the service and maintenance of the plants. We
        have customized programs for preventive maintenance to make sure the
        plants are running smoothly at all times. We also undertake spare parts
        management and rejuvenation of plants and equipment.<br /> We understand that
        the sophisticated nature of major equipment requires dedicated
        adjustments, skilled maintenance, and instructions for sustained and
        satisfactory performance of equipment and systems. With that in mind,
        our after-sales service ensures, by multiple measures, plants are at
        their productive best and running smoothly.
      </span>
    </div>
  );
}

export default SecendSection;
